import React from 'react';

import useGlobalState from '../GlobalStateContext';
import { OptionalRolesOrPermissions } from '../helpers/Permissions';

import LoadingButton, { LoadingButtonProps } from './common/LoadingButton';

type Props = {
    action: () => void;
    disabled: boolean;
} & LoadingButtonProps &
    OptionalRolesOrPermissions;

export default function ButtonDecline({ action, disabled, isLoading, roles = [], permissions = [] }: Props) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <LoadingButton
            disabled={disabled}
            isLoading={isLoading}
            type="button"
            className="btn btn-danger btn-sm mb-3 mr-2"
            key="delete"
            onClick={action}
        >
            <i className="fas fa-times" /> decline
        </LoadingButton>
    ) : null;
}
